import { useNavigate, useParams } from "react-router-dom";
import DynamicFormPage from "../../components/DynamicFormPage";
import { getMetalDetails } from "../../helpers/http_metals_requests";
import { useQuery } from "@tanstack/react-query";

const priceKindOptions = [
    { value: 1, label: "Usa cotação de ouro 18K" },
    { value: 2, label: "Usa cotação de ouro 10K" },
    { value: 3, label: "Usa cotação de prata" },
];

export default function MetalDetails() {
    const navigate = useNavigate();
    const { id } = useParams();

    const { data, isFetching } = useQuery({
        queryKey: ["getMetalDetails", id],
        queryFn: () => getMetalDetails(id),
        staleTime: 1000 * 5,
    });

    const { data: metalData } = data?.data ?? {};

    const formFieldList = [
        {
            title: "Metal - Detalhes",
            fields: [
                { name: "name", label: "Nome", type: "text" },
                { name: "color", label: "Cor", type: "text" },
                { name: "price_kind", label: "Cotação", type: "select", options: priceKindOptions },
                { name: "position", label: "Ordem", type: "number" },
                { name: "is_active", label: "Ativo", type: "switch" },
            ],
        },
    ];

    return (
        <DynamicFormPage
            isLoading={isFetching}
            details
            initialData={metalData}
            title="Metal - Detalhes"
            formFieldList={formFieldList}
            onCancel={() => navigate(-1)}
        />
    );
}
